import React, { PureComponent } from 'react'
import ProfessionItem           from './ProfessionItem'
import { getProfession }        from '../../../api/profession'
import PropTypes                from 'prop-types'

class Classify extends PureComponent {

  static propTypes = {
    type: PropTypes.number,
  }

  state = {
    categoryName: '',
    majorMap: {},
    openedId: null,
    classifyList: [],
  }

  componentDidMount() {
    const { match } = this.props
    const param = {
      _s_category_id: match.params.id,
      limit: 999,
    }
    const classifyMap = {}
    const classifyList = []
    let categoryName = ''
    getProfession(param).then(res => {
      res.data.forEach(major => {
        const category = major.category
        const classify = major.classify
        if (classifyMap[classify.id]) {
          classifyMap[classify.id].children.push(major)
        } else {
          classifyMap[classify.id] = classify
          classify.children = [major]
          classifyList.push(classify)
        }
        // 获取category的名称
        if (String(category.id) === match.params.id) {
          categoryName = category.name
        }
      })
      this.setState({
        classifyList,
        categoryName,
      })
    })
  }

  getMajors(classifyId) {
    const { openedId } = this.state
    if (openedId === classifyId) {
      this.setState({
        openedId: null,
      })
    } else {
      this.setState({
        openedId: classifyId,
      })
    }
  }


  handleBack() {
    const { history, match } = this.props
    const urlArray = match.url.split('/')
    urlArray.pop()
    history.replace(urlArray.join('/'))
  }

  renderList() {
    const { classifyList, openedId } = this.state
    return classifyList.map((d, i) => (
      <div className="classify" key={i}>
        <div className="classify-item" onClick={this.getMajors.bind(this, d.id)}>
          {openedId === d.id
            ? <svg className="icon icon-indicator_1">
              <use xlinkHref="#icon-indicator_1"></use>
            </svg>
            : <svg className="icon icon-indicator_2">
              <use xlinkHref="#icon-indicator_2"></use>
            </svg>}
          <h4>{d.name}</h4>
          <span>{d.children.length}个职业</span>
        </div>
        {openedId === d.id && <div className="major-list">{this.renderProfessionList(d.children)}</div>}
      </div>
    ))
  }

  renderProfessionList(list) {
    const { history } = this.props
    if (Array.isArray(list)) {
      return list.map((d, i) =>
        <ProfessionItem
          key={i}
          major={d}
          history={history}/>
      )
    }
  }

  render() {
    const { categoryName } = this.state
    return (
      <div>
        <div className="classify-banner">
          <div>
            <p>职业一级类目</p>
            <h2>{categoryName}</h2>
          </div>
          <a className="btn-backto-category" onClick={this.handleBack.bind(this)}>
            <span>切换职业方向</span>
            <i></i>
          </a>
        </div>
        <div className="classify-title">职业二级类目</div>
        {this.renderList()}
      </div>
    )
  }
}

export default Classify


// WEBPACK FOOTER //
// ./src/pages/Profession/List/Classify.js